<template>
  <article class="quote" :data-theme="$store.state.route.name === 'about' ? 'inverted' : 'normal'">
    <section class="quote__cont">
      <q class="quote__text" v-html="quote.content" data-anim="title">
        {{ quote.content }}
      </q>

      <div class="quote__description">
        <h3 data-anim="title">{{ quote.title }}</h3>
        <p data-anim="text">{{ quote.description }}</p>
      </div>
    </section>

    <figure class="quote__image-cont" data-parallax="0.3">
      <img v-lazy="switchImg" :alt="quote.alt">
      <div class="quote__image" v-lazy:background-image="switchImg"></div>
    </figure>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Quote',

  props: ['data'],

  data() {
    return {
      quote: {},
    };
  },

  computed: {
    ...mapGetters(['getDataCityComponent']),

    switchImg() {
      if ((window.chrome && window.chrome.webstore) || (window.opr && window.opr.addons)) {
        return `${this.quote.url}.webp`;
      }
      return `${this.quote.url}.jpg`;
    },
  },

  created() {
    if (this.$store.state.route.name === 'about') {
      this.quote = this.data;
    } else {
      this.quote = this.getDataCityComponent(this.$route.params.city, 'quote');
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.quote {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 40px 20px 100px 20px;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  @include mq(sm) {
    padding: 0;
  }

  &__cont,
  &__image-cont {
    position: relative;
    display: inline-block;
  }

  &__cont {
    width: 100%;
    padding: 40px;
    box-sizing: border-box;

    @include mq(sm) {
      width: 50%;
      padding: 100px 50px 100px 100px;
      box-sizing: border-box;
    }
  }

  &__description {
    position: absolute;
    margin-top: 40px;

    @include mq(sm) {
      margin-top: 80px;
    }

    h3 {
      font-size: 1rem;
    }
  }

  &__image-cont {
    position: absolute;
    width: 80%;
    right: 0;
    margin: 0;
    padding: 0;

    transform: translateX(40px);
    overflow: hidden;
    z-index: -1;

    opacity: 0.7;
    @include aspect-ratio(2, 3);

    @include mq(sm) {
      position: relative;
      width: 50%;
      opacity: 1;
      z-index: 1;
    }

    img {
      @include visually-hidden;
    }
  }

  &__image {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}

q {
  position: relative;
  display: inline-block;

  font-size: 2rem;
  font-style: italic;
  color: $color-light;

  &::before,
  &::after {
    position: absolute;
    height: 36px;

    font-size: 5rem;
    color: transparent;
    -webkit-text-stroke: 2px $color-blue;
  }

  &::before {
    top: -30px;
    left: -60px;
  }

  &::after {
    content: "";
  }
}

[data-theme="inverted"] {
  .quote__cont {
    order: 2;
  }

  .quote__image-cont {
    order: 1;
    transform: translateX(-40px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Quote.vue